import React from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dropdown } from 'primereact/dropdown';
import axios from 'axios';
import { MultiSelect } from 'primereact/multiselect';
import { InputText } from 'primereact/inputtext';
import { Toolbar } from 'primereact/toolbar';
import { Button } from 'primereact/button';
import MenubarView from './MenubarView';
import { useEffect, useState,useRef } from 'react';
import { FilterMatchMode } from 'primereact/api';
import { Dialog } from 'primereact/dialog';
import { InputTextarea } from 'primereact/inputtextarea';
import { Toast } from 'primereact/toast';
import { useNavigate } from "react-router";


const KeywordView = (props) => {
    const toast = useRef(null);
    const [entries, setEntries] = useState(null);
    const [selectedEntries, setSelectedEntries] = useState(null);
    const [categories,setCategories] = useState(null);
    const [categoriesWithIds,setCategoriesWithIds] = useState(null)
    const [entryDialog,setEntryDialog] = useState(false);
    const [count,setCount] = useState (0);
    
    const [filters,setFilters] = useState(
        {
        categoryname: { value: null, matchMode: FilterMatchMode.IN },
        name: { value: null, matchMode: FilterMatchMode.CONTAINS }
    })
    const [entry, setEntry] = useState({
        id:null,
        categoryname: null,
        name: null
    })
    
    const navigate  = useNavigate()
    if (localStorage.getItem('adminAccess') !== 'true')  
        navigate('/unauthorized')

    useEffect(() => {
        fetchEntryData()
        fetchCategoryData()
    }, [])

    const fetchEntryData = (e) => {
        const token = localStorage.getItem('bearerToken')
        const config = {
            headers: { Authorization: `Bearer ${token}` }
        }
        setEntries(null);
        const url =   '/v1/keywordentries'
        axios.get(url,config)
        .then(response => {
            setEntries(response.data)
        })
    }


    const fetchCategoryData = () => {
        const token = localStorage.getItem('bearerToken')
        const config = {
            headers: { Authorization: `Bearer ${token}` }
        };
        const url =   '/v1/categoryentries'; 
        axios.get(url,config)
        .then(response => {
            setCategoriesWithIds(response.data);
            const arr = [];
            for(var i in response.data)
                arr.push(response.data[i].name)
            setCategories(arr)
        })  
    }

    const onRowEditComplete = (e) => {
        
        entries.forEach(item => {
            if (item.id === e.newData.id) {
                item.name=e.newData.name
                item.categoryname=e.newData.categoryname
            }
        })
        let body = 'categoryid=' + getCategoryId(e.newData.categoryname) + '&name=' + e.newData.name;
        let uri =   '/v1/updatekeywordentry/' + e.newData.id
        const token = localStorage.getItem('bearerToken')
        const config = {
            headers: { Authorization: `Bearer ${token}` }
        };
        axios.post(uri,body,config)
            .catch(err => {
                throw err
        })
    };

    const nameEditor = (options) => {
        return <InputText type="text" value={options.value} onChange={(e) => options.editorCallback(e.target.value)} />;
    };
   

    const categoryEditor = (options) => {
        return (
            <Dropdown
                value={options.value}
                options={categories}
                onChange={(e) => {
                    options.editorCallback(e.value)
                }}
            />
        );
    };


    const categoryBodyTemplate = (rowData) => {
        return (<div>{rowData.categoryname}</div>);
    };


    const categoryFilterTemplate = (options) => {
        return (
            <MultiSelect
                value={options.value}
                options={categories}
                onChange={(e) => options.filterApplyCallback(e.value)}
                placeholder="Select Category"
                className="p-column-filter"
                maxSelectedLabels={1}
                style={{ minWidth: '14rem' }}
            />
        );
    };


    const getCategoryId = (name) => {
        let result  = '';
        categoriesWithIds.forEach(item => {
            if (item.name === name) result=item.id;});
        return result;
    };

   
    
 
    const reset = () => {
        setFilters(
            {categoryname: { value: null, matchMode: FilterMatchMode.IN },
            name: { value: null, matchMode: FilterMatchMode.CONTAINS }
        });
       
    }

    const deleteSelectedEntries = () =>{
        const token = localStorage.getItem('bearerToken')
        const config = {
            headers: { Authorization: `Bearer ${token}` }
        }
        let succeeded =  true
        selectedEntries.forEach(item => {
            var uri =   '/v1/deletekeywordentry/' + item.id;
            axios.post(uri,{},config)
            .catch(
                err => {
                    succeeded = false
                    throw err
            })   
        })
        if (succeeded) {
            let es = entries.filter(entry => !selectedEntries.includes(entry));
            setEntries(es);
            setSelectedEntries(null);
        }
       //toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Entries Deleted', life: 3000 });
    }
    const openNew = () => {
        setEntryDialog(true);
    }

    const hideDialog = () => {
        setEntryDialog(false);
        setEntry({id:null,
            categoryname: null,
            name: null
        })
    }
 

    const addEntry  = () => {
        let body = '&categoryid=' + entry.categoryid + '&name=' + entry.name;
        let uri =   '/v1/addkeywordentry';
        const token = localStorage.getItem('bearerToken')
        const config = {
            headers: { Authorization: `Bearer ${token}` }
        };
        
        axios.post(uri,body,config)
            .then(function (response) {
                entry.id = response.data.insertId;
                entries.push(entry)
                hideDialog()
                //toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Entry Created ', life: 3000 });
            })
            .catch(err => {
                hideDialog()
                console.error(err)
                throw err
                //toast.current.show({ severity: 'failure', summary: 'Unsucessful', detail: 'Entry Creation Failed ', life: 3000 });
        })
    }

    const calculateTotals = (options) => {
        setCount(options.length)
    }

    const entryDialogFooter = () => {   
       return (
       <React.Fragment>
            <Toast ref={toast}></Toast>
            <Button label="Cancel" icon="pi pi-times" className="p-button-text" onClick={hideDialog} />
            <Button label="Save" icon="pi pi-check" className="p-button-text" onClick={addEntry} />
        </React.Fragment>
       );
    }

    const leftToolbarTemplate = () => {
        return (
            <React.Fragment>
                <Toast ref={toast}></Toast>
                <Button label="New" icon="pi pi-plus" className="p-button-success p-mr-2"  onClick={openNew}/>
                <Button label="Delete" icon="pi pi-trash" className="p-button-danger p-mr-2" onClick={deleteSelectedEntries}/>
                <Button label="Clear" className="p-button-outlined" icon="pi pi-filter-slash" onClick={reset} />
            </React.Fragment>
        )
    }

    const rightToolbarTemplate = () => {
        if (count === 0) {entries && calculateTotals(entries)};
        return (
            <React.Fragment>
                <div  style={{'text-align':'left'}}> <span style={{'color':'orange'}}>{count}</span> keyword entries</div>
            </React.Fragment>
        )
    }

    const mystyle = {
        display: 'block',
        marginLeft: 'auto',
        marginRight: 'auto',
        paddingTop: '100px',
        width: '50%',
        height: '50%'
    }

        
    if (entries === null) {
        return (
            <img alt='loading' style={mystyle} src='./logo.gif'/>
        )
    } else {
    return (
        <>  
            
            <div><MenubarView/></div>
            <Toolbar className="p-mb-2" start={leftToolbarTemplate} end={rightToolbarTemplate}></Toolbar>
            <div className="card p-fluid">
                
                <DataTable  value={entries} editMode="row" dataKey="id" filters={filters} filterDisplay="row" paginator rows={50}
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                    rowsPerPageOptions={[50,75,100]} onRowEditComplete={onRowEditComplete} selection={selectedEntries}  onSelectionChange={(e) => 
                    setSelectedEntries(e.value)} tableStyle={{ minWidth: '50rem' }} emptyMessage="No records found" onValueChange={calculateTotals}>
                    
                    <Column selectionMode="multiple" headerStyle={{minWidth:'3rem'}}/>
                    <Column rowEditor headerStyle={{ width:'10%', minWidth:'7rem'}} bodyStyle={{ textAlign: 'center' }}/>
                    <Column field="id" header="ID" sortable/>
                    <Column header="KEYWORD" field="name" filterField="name" editor={nameEditor} filter filterPlaceholder="Search by Keyword" style={{ width: '30%' }} sortable/>
                    <Column header="CATEGORY" field="categoryname" filterField="categoryname" filter showFilterMenu={false} filterElement={categoryFilterTemplate} body={categoryBodyTemplate} editor={categoryEditor} sortable style={{ minWidth: '14rem' }}/>
                
                </DataTable>
            </div>
            <div>
            <Dialog visible={entryDialog} style={{ width: '600px'}} header="Keyword Entry" modal  footer={entryDialogFooter} onHide={hideDialog}> 
                <div className="p-field p-col-12 p-md-48">
                    <span className="p-float-label">
                        <Dropdown id="entryDialogCategoryField" style={{'text-align':'left', 'minWidth': '14rem'}} value={entry.categoryname} options={categories} 
                        onChange={
                            (e) => setEntry({...entry,categoryid:getCategoryId(e.target.value),categoryname:e.target.value
                            })
                        }
                        />
                        <label htmlFor="entryDialogCategoryField">Select Category</label>
                    </span>
                </div>
                <div className="p-field p-col-12 p-md-24">
                    <span className="p-float-label">
                    <InputTextarea id="entryDialogNameField" value={entry.description} onChange={(e) => setEntry({...entry,name:e.target.value})} rows={16} cols={40} />
                    <label htmlFor="entryDialogNameField">Enter Keyword</label>
                    </span>
                </div>
            </Dialog>
            </div>
        </>
    );
}
}
export default KeywordView;